"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navbar = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const sitemap_1 = require("@/sitemap");
const utils_1 = require("@/utils");
const large_text_1 = require("@/utils/large-text");
require("./navbar.css");
let Navbar = class Navbar extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.largeText = (0, large_text_1.isLargeText)();
        this.handleLargeTextChange = (e) => {
            this.largeText = (0, large_text_1.saveLargeText)(e.detail.checked);
        };
    }
    render() {
        return (0, lit_1.html) `
      <nav class="navbar">
        <mm-flex gap="2">
          <mm-hamburger-button
            aria-label="전체메뉴"
            aria-controls="site-sidebar"
          ></mm-hamburger-button>
          <a class="navbar-logo" href="./index.html" aria-label="홈"></a>
        </mm-flex>

        <div class="navbar-user">
          <mm-switch ?checked=${this.largeText} @change=${this.handleLargeTextChange}>
            큰글씨
          </mm-switch>
          <mm-theme-selector></mm-theme-selector>
          <mm-navbar-search></mm-navbar-search>
        </div>
      </nav>
      <div class="navbar-backdrop"></div>

      <mm-fixed-bottom class="site-bottom-bar">
        <mm-bottom-bar .items=${this.bottomBarItems}></mm-bottom-bar>
      </mm-fixed-bottom>
    `;
    }
    get bottomBarItems() {
        return sitemap_1.SITEMAP.filter(node => node.type === 'standalone' && node.id !== 'foundations').map(node => ({
            label: node.title,
            href: `${node.id}.html`,
            icon: node.icon,
            active: node.id === (0, utils_1.getCurrentPageId)(),
        }));
    }
    /**
     * Light DOM을 유지한다. 햄버거 버튼이 `aria-controls="site-sidebar"`로 mm-sidebar를 가리키는데,
     * aria-controls는 shadow 경계를 넘지 못해 shadow root에 두면 사이드바가 트리거를 찾지 못한다.
     * 따라서 스타일도 shadow에 넣을 수 없어 navbar.css를 컴포넌트 폴더에서 함께 가져온다.
     */
    createRenderRoot() {
        return this;
    }
};
__decorate([
    (0, decorators_js_1.state)()
], Navbar.prototype, "largeText", void 0);
Navbar = __decorate([
    (0, decorators_js_1.customElement)('mm-navbar')
], Navbar);
exports.Navbar = Navbar;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibmF2YmFyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmF2YmFyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUFzQztBQUN0QyxxREFBd0Q7QUFFeEQsdUNBQW1DO0FBQ25DLG1DQUEwQztBQUMxQyxtREFBK0Q7QUFDL0Qsd0JBQXFCO0FBR2QsSUFBTSxNQUFNLEdBQVosTUFBTSxNQUFPLFNBQVEsZ0JBQVU7SUFBL0I7O1FBQ1ksY0FBUyxHQUFHLElBQUEsd0JBQVcsR0FBRSxDQUFBO1FBNkJsQywwQkFBcUIsR0FBRyxDQUFDLENBQW9DLEVBQUUsRUFBRTtZQUN2RSxJQUFJLENBQUMsU0FBUyxHQUFHLElBQUEsMEJBQWEsRUFBQyxDQUFDLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxDQUFBO1FBQ2xELENBQUMsQ0FBQTtJQXFCSCxDQUFDO0lBbERDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzs7Ozs7Ozs7OztnQ0FXaUIsSUFBSSxDQUFDLFNBQVMsWUFBWSxJQUFJLENBQUMscUJBQXFCOzs7Ozs7Ozs7O2dDQVVwRCxJQUFJLENBQUMsY0FBYzs7S0FFOUMsQ0FBQTtJQUNILENBQUM7SUFNRCxJQUFZLGNBQWM7UUFDeEIsT0FBTyxpQkFBTyxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLElBQUksQ0FBQyxJQUFJLEtBQUssWUFBWSxJQUFJLElBQUksQ0FBQyxFQUFFLEtBQUssYUFBYSxDQUFDLENBQUMsR0FBRyxDQUN4RixJQUFJLENBQUMsRUFBRSxDQUFDLENBQUM7WUFDUCxLQUFLLEVBQUUsSUFBSSxDQUFDLEtBQUs7WUFDakIsSUFBSSxFQUFFLEdBQUcsSUFBSSxDQUFDLEVBQUUsT0FBTztZQUN2QixJQUFJLEVBQUUsSUFBSSxDQUFDLElBQUk7WUFDZixNQUFNLEVBQUUsSUFBSSxDQUFDLEVBQUUsS0FBSyxJQUFBLHdCQUFnQixHQUFFO1NBQ3ZDLENBQUMsQ0FDSCxDQUFBO0lBQ0gsQ0FBQztJQUVEOzs7O09BSUc7SUFDSCxnQkFBZ0I7UUFDZCxPQUFPLElBQUksQ0FBQTtJQUNiLENBQUM7Q0FDRixDQUFBO0FBcERVO0lBQVIsSUFBQSxxQkFBSyxHQUFFO3lDQUFrQztBQUQvQixNQUFNO0lBRGxCLElBQUEsNkJBQWEsRUFBQyxXQUFXLENBQUM7R0FDZCxNQUFNLENBcURsQjtBQXJEWSx3QkFBTSJ9